import axios from 'axios';

export const getCourseSteps = async (courseID) => {
  const response = await axios.get(`/courseStep/course/:courseID?courseID=${courseID}`);
  const results = response.data;
  return results;
};
